export default __webpack_public_path__ + "static/desktop-planning-ae99e155b774b47411f1d69061bccf8a.png";